import { Component, OnInit, ViewEncapsulation } from '@angular/core';

// classes
import { CategoryHandler } from 'src/app/core/classes/category-handler';
import { LocationHandler } from 'src/app/core/classes/location-handler';

// services
import { FiltrationService } from './services/filtration.service';

@Component({
  selector: 'app-filtration',
  templateUrl: './filtration.component.html',
  styleUrls: ['./filtration.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FiltrationComponent implements OnInit {

  /**
   *
   */
  constructor(
    public Filtration: FiltrationService,
  ) {}

  ngOnInit(): void {
    this.Filtration.watchChange.next(null)
  } 
  
  /**
   * submit
   */
  public submit(): void {


    /**
     * fire close
     */
    this.Filtration.close();

    // ES6 Destruction
    let { value } = this.FiltrationForm;

    /**
     * remove nullable values
     */
    value = Object.keys(value)
            .map(controlName => value[controlName] ? [controlName, value[controlName]] : null)
            .filter(controlName => controlName);

    /**
     * emit new value
     */
    this.Filtration.watchChange.next(Object.fromEntries(value));

  }

  /**
   * Getters & Setters
   */

  /**
   * 
   */
  public get FiltrationForm() {
    return this.Filtration.Form
  }

  /**
   * categoryHandler
   */
  public get categoryHandler(): CategoryHandler {
    return this.Filtration.categoryHandler
  }

  /**
   * locationHandler
   */
  public get locationHandler(): LocationHandler {
    return this.Filtration.locationHandler
  }    

  /**
   * 
   */
  public get isLoading(): boolean {
    return this.Filtration.isLoading
  }
  
  
  /**
   * 
   */
  ngOnDestroy(): void {}

}
